import type { StateCreator } from 'zustand';
import { clientsApi, type Client } from '../services/clientsApi';

export interface ClientsSlice {
  clients: Client[];
  clientsLoading: boolean;
  clientsError: string | null;

  fetchClients: () => Promise<void>;
  createClient: (data: Partial<Client>) => Promise<Client>;
  updateClient: (id: number, data: Partial<Client>) => Promise<void>;
  archiveClient: (id: number) => Promise<void>;
}

export const createClientsSlice: StateCreator<ClientsSlice, [], [], ClientsSlice> = (set, get) => ({
  clients: [],
  clientsLoading: false,
  clientsError: null,

  fetchClients: async () => {
    set({ clientsLoading: true, clientsError: null });
    try {
      const clients = await clientsApi.list();
      set({ clients });
    } catch (e) {
      set({ clientsError: (e as Error).message });
    } finally {
      set({ clientsLoading: false });
    }
  },

  createClient: async (data) => {
    const created = await clientsApi.create(data);
    await get().fetchClients();
    return created;
  },

  updateClient: async (id, data) => {
    await clientsApi.update(id, data);
    await get().fetchClients();
  },

  archiveClient: async (id) => {
    await clientsApi.archive(id);
    await get().fetchClients();
  },
});
